import React from 'react';

import { useAdmonitionStyles } from '../Admonition/Admonition.context';
import { Text } from '../Text/Text';

export interface AdmonitionBodyProps {
  children: React.ReactNode;
}

export const AdmonitionBody = ({ children }: AdmonitionBodyProps) => {
  const styles = useAdmonitionStyles();

  return (
    <Text as="div" size="sm" __orbitStyleConfig={styles.body}>
      {children}
    </Text>
  );
};
